import { useCallback } from "react";
import {
  CasinoActionCreators,
  RealityCheckActionCreators
} from "../redux/action-creators/index.js";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { CasinoSelectors } from "../redux/selectors/index.js";
import emptyState from "../redux/store/emptyState.js";
import { AppFeatures } from "../constants/featureFlags.js";
import { useFeature } from "./useFeature.js";
import { MessageBrokerUtils, TrackingUtils } from "../utils/index.js";
import { Channel, DialogType, Topic } from "../constants/index.js";

export const useLogout = () => {
  const dispatch = useDispatch();
  const isLugasLogoutActive = useFeature(AppFeatures.LUGAS_LOGOUT);
  const gamblingSession = useSelector(CasinoSelectors.gamblingSession);

  const resetGamblingSession = useCallback(() => {
    dispatch(
      CasinoActionCreators.setGamblingSession(emptyState.casino.gamblingSession)
    );
  }, [dispatch]);

  const resetSportSessionDetails = useCallback(() => {
    dispatch(
      RealityCheckActionCreators.setSportSessionDetails(
        emptyState.realityCheck.sportSessionDetails
      )
    );
  }, [dispatch]);

  const showLogoutPopup = () => {
    if (gamblingSession.sessionStatus === 1) {
      TrackingUtils.sendAnalytics({
        dataCategory: "Logout popup",
        dataAction: "view",
        dataLabel: "Casino session summary"
      });
      MessageBrokerUtils.publish({
        channel: Channel.UI,
        topic: Topic.Dialog,
        headers: {
          publisher: "UAA"
        },
        data: {
          dialogType: DialogType.CasinoSessionSummary,
          options: gamblingSession
        }
      });
    } else if (isLugasLogoutActive) {
      TrackingUtils.sendAnalytics({
        dataCategory: "Logout popup",
        dataAction: "view",
        dataLabel: "Lugas logout"
      });
      MessageBrokerUtils.publish({
        channel: Channel.UI,
        topic: Topic.Dialog,
        headers: {
          publisher: "UAA"
        },
        data: { dialogType: DialogType.LugasLogout }
      });
    } else {
      TrackingUtils.sendAnalytics({
        dataCategory: "Logout popup",
        dataAction: "view",
        dataLabel: "Logout"
      });
      MessageBrokerUtils.publish({
        channel: Channel.UI,
        topic: Topic.Dialog,
        headers: {
          publisher: "UAA"
        },
        data: { dialogType: DialogType.Logout }
      });
    }
  };

  return { resetGamblingSession, resetSportSessionDetails, showLogoutPopup };
};
